/*
  CUSTOM 2026-08-07 — Doppeltipp zoomt nicht mehr die Seite.

  `html { touch-action: manipulation }` steht bereits in assets/theme.css und sollte den
  Doppeltipp-Zoom eigentlich unterbinden. In der Praxis greift das nicht ueberall: Die Regel
  wirkt pro Element, und einzelne Bereiche (Slider, Galerie) setzen eigene touch-action-Werte,
  wodurch der Browser dort wieder auf sein Standardverhalten zurueckfaellt.

  Deshalb hier zusaetzlich der direkte Weg: Kommt der zweite Tipp innerhalb des Zeitfensters,
  wird die Standardaktion des Browsers unterdrueckt. Das ist die einzige Methode, die
  unabhaengig vom getroffenen Element funktioniert.

  Bewusst NICHT ueber `maximum-scale=1` im Viewport-Tag geloest: Das wuerde auch das
  Auseinanderziehen mit zwei Fingern sperren — eine Zugaenglichkeitshuerde, die iOS ohnehin
  seit Version 10 ignoriert.

  AUSNAHME Produktbild: Dort soll der Doppeltipp die grosse Ansicht oeffnen. Das Theme hat
  dafuer bereits einen unsichtbaren Knopf ueber jedem Medium (is="media-lightbox-button",
  siehe snippets/product-media-gallery.liquid). Der wird hier ausgeloest, statt zu zoomen.
*/
(() => {
  if (window.__customNoDoubleTapZoom) return;
  window.__customNoDoubleTapZoom = true;

  /* 320ms ist das ueblich angesetzte Fenster fuer einen Doppeltipp. Kuerzer waere zu strikt
     (langsamere Nutzer), laenger wuerde zwei bewusste Einzeltipps zusammenziehen. */
  const FENSTER = 320;
  const MEDIUM = '.product__media, [data-media-id], .product__gallery-container .media';

  let letzterTipp = 0;
  let letzterPunkt = { x: 0, y: 0 };

  document.addEventListener(
    'touchend',
    (ereignis) => {
      /* Mehrfingergesten (Auseinanderziehen) nie anfassen. */
      if (ereignis.touches.length > 0 || ereignis.changedTouches.length !== 1) return;

      const beruehrung = ereignis.changedTouches[0];
      const jetzt = Date.now();
      const abstand = Math.hypot(beruehrung.clientX - letzterPunkt.x, beruehrung.clientY - letzterPunkt.y);

      /* Zwei Tipps weit auseinander sind kein Doppeltipp, sondern zwei getrennte Klicks. */
      const istDoppeltipp = jetzt - letzterTipp <= FENSTER && abstand < 40;

      letzterTipp = jetzt;
      letzterPunkt = { x: beruehrung.clientX, y: beruehrung.clientY };

      if (!istDoppeltipp) return;

      /* Unterdrueckt den Zoom — und den zweiten Klick, den der Browser sonst nachschiebt. */
      ereignis.preventDefault();
      letzterTipp = 0;

      const medium = ereignis.target.closest(MEDIUM);
      if (!medium) return;

      /* Grosse Ansicht oeffnen. Der Knopf liegt als unsichtbare Flaeche ueber dem Bild. */
      const knopf = medium.querySelector('button[is="media-lightbox-button"]')
        || medium.closest('[data-media-id]')?.querySelector('button[is="media-lightbox-button"]');

      if (knopf) knopf.click();
    },
    { passive: false }
  );
})();
